const state = {
  global_jobs: {},
  job: {},
  companies: [],
  company: {},
}
export default state
